import axios from 'axios';
import { Box, IconButton } from '@mui/material';
import { useTheme } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { createURL, styles } from './utils';
import ReplayIcon from '@mui/icons-material/Replay';

export interface StaticImageMapProps {
  value: {
    lat: string | number;
    lng: string | number;
  };
  zoom?: number | string;
  pitch?: number | string;
  theme?: 'light' | 'dark';
  bearing?: number | string;
}

export default function StaticImageMap(props: StaticImageMapProps): JSX.Element {
  const { palette } = useTheme();
  const [src, setSrc] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const mode = palette.mode;

  const configs = useMemo(() => ({ ...props, theme: mode }), [props, mode]);

  useEffect(() => {
    handleOnRefresh(configs);
  }, [configs]);

  const handleOnRefresh = (configs: StaticImageMapProps) => {
    setIsLoading(true);
    axios
      .get(createURL(configs), { responseType: 'blob' })
      .then(({ data }) => setSrc(URL.createObjectURL(data)))
      .catch(() => {})
      .finally(() => setIsLoading(false));
  };

  return (
    <Box sx={styles(isLoading ? require('../../../../../assets/googleMapsImg.png') : src)}>
      <IconButton onClick={() => handleOnRefresh(configs)}>
        <ReplayIcon />
      </IconButton>
    </Box>
  );
}
